import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { MyAbsence, MyAbsenceCategory, MyAbsencePayload } from '../Models/my-planning.model';

/** Self-Service des Benutzer-Dashboards: eigene Abwesenheiten und Kalender-Link. */
@Injectable({ providedIn: 'root' })
export class MyPlanningService {
  constructor(private http: HttpClient) { }

  // ---- Eigene Abwesenheiten ----
  getMyAbsences(): Observable<MyAbsence[]> {
    return this.http.get<MyAbsence[]>(`${environment.apiBaseUrl}/myabsence`);
  }

  getMyAbsenceCategories(): Observable<MyAbsenceCategory[]> {
    return this.http.get<MyAbsenceCategory[]>(`${environment.apiBaseUrl}/myabsence/categories`);
  }

  requestMyAbsence(payload: MyAbsencePayload): Observable<MyAbsence> {
    return this.http.post<MyAbsence>(`${environment.apiBaseUrl}/myabsence`, payload);
  }

  cancelMyAbsence(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/myabsence/${id}`);
  }

  // ---- Persönlicher Kalender-Link (Outlook-Vorschläge in „Mein Kalender“) ----
  getMyFeed(): Observable<{ url: string | null }> {
    return this.http.get<{ url: string | null }>(`${environment.apiBaseUrl}/mycalendarfeed`);
  }

  setMyFeed(url: string | null): Observable<void> {
    return this.http.put<void>(`${environment.apiBaseUrl}/mycalendarfeed`, { url });
  }
}
